// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upload-container .el-upload {\r\n  width: auto;\n}\n.el-upload-list {\r\n  max-height: 350px;\r\n  overflow: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
